import * as R from 'ramda'
import {
  ContactPhoneStatus,
  SelectedContacts,
  SelectedContactsPhonesStatus,
} from '$logic/contacts/types'
import { showSuccessSnackbar } from '$comp/snackbars'
import { t } from '$i18n'

export async function doesContactApiSupportProps(props: ContactProperty[]) {
  const supportedProps = (await navigator.contacts?.getProperties()) || []
  return props.every(prop => supportedProps.includes(prop))
}

export function showAddContactsSnackbars(
  contacts: SelectedContacts,
  phonesStatus: SelectedContactsPhonesStatus,
) {
  const contactsStatus: Array<{ name: string; status: ContactPhoneStatus }> =
    Object.entries(contacts).map(([name, phones]) => {
      const contactPhonesStatus = phones.map(
        p => phonesStatus[p] || 'noAppAccount',
      )

      return {
        name,
        status: contactPhonesStatus.includes('addedToContacts')
          ? 'addedToContacts'
          : 'noAppAccount',
      }
    })

  const groupedStatus = R.groupBy(({ status }) => status, contactsStatus)
  Object.entries(groupedStatus).forEach(([status, contacts]) => {
    if (status === 'noAppAccount')
      showSuccessSnackbar(
        contacts.length === 1
          ? t('syncIOSAccounts.selectedContactDoesntHaveAppAccount')
          : t('syncIOSAccounts.nContactsDoesntHaveAppAccount')(contacts.length),
      )
    else
      showSuccessSnackbar(
        contacts.length === 1
          ? t('syncIOSAccounts.xAddedToContacts')(contacts[0].name)
          : t('syncIOSAccounts.xAndNPersonsAddedToContacts')(
              contacts[0].name,
              contacts.length - 1,
            ),
      )
  })
}
